import React from 'react';
import './style.css';

const FilterTag = (props) => {

  const {
    text,
    onClose
  } = props;

  const trimTag = (word) => {
    if (word.length < 30) {
      return word;
    }
    return `${word.substring(0, 30)}...`;
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginRight: 4, marginTop: 8}}>
        <div
          className='filter-tag'
        >
          { trimTag(text) }
        </div>
        <div
          onClick={() => onClose()}
          className='filter-tag-close-icon'
        >
          X
        </div>
      </div>
    </div>
  )
};

export default FilterTag;


// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/FilterTag.jsx